
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 90"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h150v90H0","fill":"#fff"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M150 0H37l23 9-23 9 23 9-23 9 23 9-23 9 23 9-23 9 23 9-23 9h113"}})])
          )
        }
      }
    